<template>
  <div class="flex-tool office-net-board" v-show="!isOfficeNet || lastIsOfficeNet !== isOfficeNet">
    <el-popover
      ref="officeNetPopover"
      placement="bottom"
      trigger="hover"
      :visible-arrow="false"
      popper-class="office-net-board__popover"
      width="240"
    >
      <div class="office-net-board__pop" v-loading="loading">
        <div class="row">
          <div class="title">检测时间：</div>
          <div class="value">{{ detectTime }}</div>
          <div class="refresh-btn" @click="refresh"><i class="el-icon-refresh"></i> 刷新</div>
        </div>
        <div class="row">
          <div class="title">网络环境：</div>
          <div class="value">{{ label }}</div>
        </div>
        <div class="row">
          <div class="title">IP地址：</div>
          <div class="value">{{ ipAddress }}</div>
        </div>
        <div class="row" v-show="isOfficeNet">
          <div class="title">所属大区：</div>
          <div class="value">{{ bigArea }}</div>
        </div>
        <div class="row" v-show="isOfficeNet">
          <div class="title">所属场地：</div>
          <div class="value">{{ ipItem ? ipItem.name : '' }}</div>
        </div>
      </div>
    </el-popover>
    <div class="office-net-board__content"
      :class="{ 'office-net-board__content--office-net': isOfficeNet }"
      v-popover:officeNetPopover>
      <span
        class="office-net-board__icon"
      >
        <i class="layout layout-office-network"></i>
      </span>
      <span class="office-net-board__text">{{ label }}</span>
    </div>
  </div>
</template>

<script>
import { minute, lookup } from '@/public/utils/filter'
const HTTPS_OFFICE_NET_API = 'https://localhost:18096'
const HTTP_OFFICE_NET_API = 'http://localhost:18097'
function getFirstThreeParts(ip) {
  const parts = ip.split('.')
  if (parts.length < 3) {
    return ip // 如果少于三段，返回原字符串
  }
  return parts.slice(0, 3).join('.')
}
export default {
  name: 'OfficeNetBoard',
  data () {
    return {
      // 是否为办公网络，控制圆形背景色
      isOfficeNet: true,
      officeTimer: null,
      detectTime: '',
      ipAddress: '',
      ipList: [],
      ipItem: null,
      lastRefreshTime: 0,
      REFRESH_THROTTLE_MS: 3000,
      isError: false,
      loading: false,
      isInit: false,
      lastIsOfficeNet: true,
    }
  },
  computed: {
    label () {
      if (this.isError) return '加载异常'
      return this.isOfficeNet ? '办公网络' : '非办公网络'
    },
    bigArea () {
      if (!this.ipItem) return ''
      return lookup(this.ipItem.dq, 'mcs_action_exception_dp')
    }
  },
  created () {
    this.init()
  },
  mounted () {
    window.addEventListener('mousemove', this.mouseMoveEvent)
  },
  beforeDestroy () {
    window.removeEventListener('mousemove', this.mouseMoveEvent)
    if (this.officeTimer) {
      clearInterval(this.officeTimer)
      this.officeTimer = null
    }
  },
  methods: {
    async init () {
      this.mouseXY = ''
      this.oldMouseXY = ''
      await this.getSite()
      try {
        await this.fetchOffice('http', false, false)
      } catch (err) {
        console.error('init office net failed', err)
      }
      this.startOfficePolling()
    },
    mouseMoveEvent (e) {
      this.mouseXY = `${e.x},${e.y}`
    },
    async fetchOffice (type = 'http', flush = false, showLoading = false) { // 暂时只调用http，如果https失败，则调用http
      let api = type === 'https' ? HTTPS_OFFICE_NET_API : HTTP_OFFICE_NET_API
      if (flush) { // flush为true时，强制刷新
        api = api + '/?flush=1'
      }
      return new Promise((resolve, reject) => {
        if (showLoading) {
          this.loading = true
        }
        fetch(api).then(res => res.json()).then(body => {
          const { data } = body
          let netInfo = null
          netInfo = data.find(item => item.dns_suffix.includes('ky-tech.com.cn'))
          if (!netInfo) {
            netInfo = data[0]
          }
          if (netInfo) {
            if (this.ipAddress !== netInfo.ip) {
              this.ipAddress = netInfo.ip
              const ip = getFirstThreeParts(this.ipAddress)
              const ipItem = this.ipList.find(item => item.ip.startsWith(ip))
              this.ipItem = ipItem || null
            }
            let isOfficeNet = netInfo.dns_suffix.includes('ky-tech.com.cn')
            this.lastIsOfficeNet = this.isOfficeNet
            this.isOfficeNet = isOfficeNet
            this.detectTime = minute(new Date().getTime())
            this.isError = false
            this.loading = false
            resolve(netInfo)
          } else {
            if (!this.ipAddress) {
              this.isError = true
            }
            this.loading = false
            reject(new Error('fetchOffice failed'))
          }
        })
        .catch(err => {
          this.isError = true
          this.loading = false
          reject(err)
        })
      })
    },
    // 每分钟轮询一次办公网络状态
    startOfficePolling () {
      if (this.officeTimer) {
        clearInterval(this.officeTimer)
      }
      this.officeTimer = setInterval(() => {
        if (this.mouseXY === this.oldMouseXY) {
          return
        }
        this.oldMouseXY = this.mouseXY
        this.fetchOffice('http')
      }, 60 * 1000)
    },
    async getSite () {
      const res = await this.$http('mcs.siteInfo.listAllValid', {}, {cancel: true, appkey: '50178'})
      this.ipList = res
    },
    async refresh () {
      const now = Date.now()
      if (now - this.lastRefreshTime < this.REFRESH_THROTTLE_MS) {
        this.$message.warning('刷新过于频繁，请稍后再试')
        return
      }
      this.lastRefreshTime = now
      try {
        if (this.officeTimer) {
          clearInterval(this.officeTimer)
        }
        await this.fetchOffice('http', true, true)
        this.$message.success('刷新成功')
        this.startOfficePolling()
      } catch (err) {
        console.error('refresh office net failed', err)
      }
    }
  }
}
</script>

<style lang="scss">
.office-net-board {
  color: #ffffff;
  user-select: none;
  height: 34px;
  &__icon {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-right: 4px;
    img {
      width: 10px;
      height: 10px;
      display: block;
    }
  }
  &__content {
    display: flex;
    align-items: center;
    height: 100%;
    &--office-net {
      .office-net-board__icon {
        color: rgba(69, 60, 90, 1);
        font-size: 14px;
      }
    }
  }

  &__text {
    font-size: 13px;
    color: #453c5a;
    line-height: 18px;
    white-space: nowrap;
  }
}

.office-net-board__popover {
  padding: 4px 8px !important;
  background-image: url('./images/office-bg.png');
  background-repeat: no-repeat;
  // background-position: right bottom;
  background-size: 100% 100%;
  .office-net-board__pop {
    display: flex;
    flex-direction: column;
    padding: 2px 0;
    .row {
      display: flex;
      align-items: center;
      height: 24px;
      line-height: 24px;

      .title {
        font-size: 12px;
        color: #1D1C23;
        width: 62px;
        text-align: right;
        font-weight: bold;
        margin-right: 2px;
      }
      .value {
        font-size: 12px;
        color: #170000;
        flex: 1;
      }
      .refresh-btn {
        font-size: 12px;
        cursor: pointer;
        color: var(--color-primary);
        margin-left: 10px;
      }
    }
  }

  .office-net-board__pop-title {
    font-weight: 600;
    color: #303133;
  }

  .office-net-board__pop-desc {
    font-size: 12px;
    line-height: 18px;
    color: #606266;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/office-net-board.vue